export type MobileV1ToastVariant = 'success' | 'warn'

export interface MobileV1Toast {
  id: number
  text: string
  variant: MobileV1ToastVariant
  duration: number
}

let nextId = 1

export function useMobileV1Toast() {
  const toasts = useState<MobileV1Toast[]>('mobile-v1-toasts', () => [])

  function push(input: { text: string; variant?: MobileV1ToastVariant; duration?: number }) {
    const toast: MobileV1Toast = {
      id: nextId++,
      text: input.text,
      variant: input.variant || 'success',
      duration: input.duration ?? 2500,
    }
    toasts.value = [...toasts.value, toast]
    setTimeout(() => remove(toast.id), toast.duration)
    return toast.id
  }

  function remove(id: number) {
    toasts.value = toasts.value.filter((t) => t.id !== id)
  }

  return { toasts, push, remove }
}
